var _g;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgVideoFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "46 / Fill / Video - No Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50261 1.2168H6.62726L8.68377 3.65158H6.55913L4.50261 1.2168Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.086 3.65158H10.8085L8.75197 1.2168H11.2599C12.2685 1.2168 13.086 2.03436 13.086 3.04288V3.65158Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40372 1.24736L4.43441 3.65158H0.912109V3.04288C0.912109 2.14861 1.55494 1.40448 2.40372 1.24736Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.086 5.27477H0.912109V10.753C0.912109 11.7615 1.72968 12.5791 2.7382 12.5791H11.2599C12.2685 12.5791 13.086 11.7616 13.086 10.753V5.27477ZM6.48887 10.8195L8.34394 9.46768C8.71495 9.19731 8.71495 8.65657 8.34394 8.38621L6.48886 7.03437C6.03027 6.70017 5.37582 7.01812 5.37582 7.5751L5.37582 10.2788C5.37582 10.8358 6.03027 11.1537 6.48887 10.8195Z",
    fill: "var(--secondary-4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFilled);
export default __webpack_public_path__ + "static/media/videoFilled.dad6c4a864bcd1c473990a0ece5f66a1.svg";
export { ForwardRef as ReactComponent };